module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section aragon diagonal gradient",
    attrs: {
      "id": "landing_community"
    }
  }, [_c('div', {
    staticClass: "ui middle aligned very relaxed center aligned stackable grid"
  }, [_c('div', {
    staticClass: "twelve wide column"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), (_vm.saleState === 0) ? _c('div', [_c('img', {
    staticClass: "ui small centered image",
    attrs: {
      "src": require("../assets/info/coin.png")
    }
  }), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.saleState !== 0) ? _c('div', [(_vm.ready) ? _c('div', {
    staticClass: "ui inverted two statistics"
  }, [(_vm.saleState !== 1) ? _c('ether') : _vm._e(), _vm._v(" "), (_vm.saleState !== 1) ? _c('dollar') : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _vm._m(2)]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n        Aragon Network token sale\n        "), _c('div', {
    staticClass: "ui hidden half divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("Create and manage unstoppable organizations")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n          May 17th\n          "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("Exact time (block number) and address will be announced on Monday 15th")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n          🎉 Sale is closed! 🎉\n          "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("Thanks to everyone who participated.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8eaef5e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hero.vue
// module id = 519
// module chunks = 1